<template>
  <!-- block -->
  <div class="block" v-if="award !== null">
    <!-- Award Name -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>Award Name</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="award.title"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
    <!-- BU -->
    <label class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>BU</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-autocomplete
          v-model="award.bu_id"
          :items="buTabs"
          placeholder="請選擇所屬BU"
          class="w-240px"
          item-text="name"
          item-value="id"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
    </label>
    <!-- Year -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>Year</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-autocomplete
          :items="yearOptions"
          v-model="award.year"
          placeholder="請選擇得獎年份"
          class="w-240px"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
    </div>
    <!-- Month -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>Month</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-autocomplete
          :items="monthOptions"
          v-model="award.month"
          placeholder="請選擇得獎月份"
          class="w-240px"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
    </div>
    <!-- Award Type -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>Award Type</h4>
      </div>
      <div
        class="flex-grow-1 flex-basis-0 my-n2"
        :class="{ 'd-flex': award.type == 2 }">
        <v-autocomplete
          :items="awardTypeOptions"
          v-model="award.type"
          placeholder="請選擇獎項類別"
          class="w-240px"
          outlined
          dense
        >
        </v-autocomplete>
        <v-autocomplete v-if="award.type == 2"
          :items="categories"
          v-model="award.product_category_id"
          placeholder="請選擇產品分類"
          class="w-240px ml-5"
          item-value="id"
          item-text="name"
          outlined
          dense
        >
        </v-autocomplete>
        <v-autocomplete  v-if="award.type == 2"
          :items="products"
          v-model="award.product_id"
          placeholder="請選擇產品型號"
          class="w-200px ml-5"
          item-value="id"
          item-text="text"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
    </div>
    <!-- Award Country -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>Award Country</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-autocomplete
          :items="countries"
          v-model="award.country_id"
          placeholder="請選擇得獎國家"
          class="w-240px"
          item-text="name"
          item-value="id"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
    </div>
    <!-- Award Image -->
    <div class="form-item d-flex py-5">
      <div class="w-240px mr-5">
        <h4>Award Image</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0">
        <ImgUploader
          :imageUrl.sync="award.image"
          dir="awards"></ImgUploader>
      </div>
    </div>
    <!-- URL -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>URL</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="award.url"
          placeholder="請輸得獎連結"
          prepend-inner-icon="mdi-link"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
    <!-- Display Order -->
    <div class="form-item d-flex pt-5">
      <div class="w-240px mr-5">
        <h4>Display Order</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-text-field
          v-model="award.order"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
// import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    // SimpleSelectWithSearchInput,
    ImgUploader,
  },
  data: () => ({
    categories: [],
    products: [],
  }),
  computed: {
    ...mapState(['buTabs']),
    ...mapState('language', ['countries']),
    ...mapState('award', ['award', 'awardTypeOptions']),
    yearOptions() {
      const startYear = 1991;
      const range = new Date().getFullYear() - startYear + 1;
      return [...Array(range).keys()].map((i) => i + startYear);
    },
    monthOptions() {
      return [...Array(12).keys()].map((i) => i + 1);
    },
  },
  watch: {
    async 'award.bu_id'() {
      this.categories = await this.allByBu(this.award.bu_id);
      this.getTargetProduct();
    },
    async 'award.product_category_id'() {
      this.getTargetProduct();
    },
  },
  methods: {
    ...mapActions('category', ['allByBu']),
    getTargetProduct() {
      this.products = [];
      const category =
        this.categories.find((item) => item.id === this.award.product_category_id);
      if (category) {
        this.products = category.products;
      }
    },
  },
};
</script>

<style></style>
